import React from 'react';
import { CHECKOUT_URL } from '../data/coachSystem';
import { PRODUCT_EVENT_PARAMS, trackMetaEvent } from '../utils/metaPixel';
type CtaButtonProps = {
  label: string;
  /** 'scroll' jumps to the final offer section, 'checkout' opens the checkout. */
  action?: 'scroll' | 'checkout';
  variant?: 'navy' | 'teal';
  size?: 'md' | 'lg';
  className?: string;
};
export function CtaButton({
  label,
  action = 'scroll',
  variant = 'navy',
  size = 'md',
  className = ''
}: CtaButtonProps) {
  const palette = variant === 'teal' ? 'bg-teal text-white hover:bg-teal-deep focus-visible:outline-teal-deep' : 'bg-navy text-white hover:bg-navy-deep focus-visible:outline-navy';
  const sizing = size === 'lg' ? 'px-7 py-4 text-[0.95rem]' : 'px-6 py-3.5 text-[0.85rem]';
  const handleScroll = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    /* Land on the price block itself so the $27 and the checkout button are
       always in view, not just the top of the offer section. */
    const target = document.getElementById('pricing') ?? document.getElementById('offer');
    if (target) {
      target.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }
  };
  const handleCheckout = () => {
    trackMetaEvent('InitiateCheckout', PRODUCT_EVENT_PARAMS);
  };
  if (action === 'checkout') {
    return <a href={CHECKOUT_URL} onClick={handleCheckout} className={`inline-flex w-full items-center justify-center gap-2 rounded-full font-semibold uppercase tracking-[0.06em] shadow-card transition-[background-color,transform,box-shadow] duration-150 ease-out hover:-translate-y-0.5 hover:shadow-lift focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 ${palette} ${sizing} ${className}`} data-id="element-26" data-mp="3ow0c6q2xrujp">
        {label} <span aria-hidden="true" data-id="element-27" data-mp="bif6hozchb25">→</span>
      </a>;
  }
  return <a href="#pricing" onClick={handleScroll} className={`inline-flex w-full items-center justify-center gap-2 rounded-full font-semibold uppercase tracking-[0.06em] shadow-card transition-[background-color,transform,box-shadow] duration-150 ease-out hover:-translate-y-0.5 hover:shadow-lift focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 ${palette} ${sizing} ${className}`} data-id="element-28" data-mp="gfoxva6anwsm">
      {label} <span aria-hidden="true" data-id="element-29" data-mp="3ruz21ynsyui8">→</span>
    </a>;
}